import React from "react";
import { Container, Form } from "reactstrap";
// Formik validation
import { useFormik } from "formik";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useHistory, useParams } from "react-router-dom";
import ResultHandler from "../../../components/ResultHandler";
import { addDeduction } from "../../../api/deductions";
import FormButtonHandler from "../../../components/FormButtonHandler";
import { useResponse } from "../../../hooks/useResponse";
import { useTranslation } from "react-i18next";
import FIELDS, { WORK_EXPERIENCE_FIELDS, WORK_EXPERIENCE_REQUIRED_FIELDS } from "./CONSTANT";
import * as Yup from "yup";
import WorkExperienceForm from './WorkExperienceForm'
import { addWorkExperience } from "../../../api/workExperience";

const TYPES = {
  'select': null,
  'add-more': [],
  'checkbox': false,
  'file' : null,
  'date': null
}

const initialValues = {};
const FIELDS_VALIDATION = {};

WORK_EXPERIENCE_REQUIRED_FIELDS.forEach((f) => {
  initialValues[f.key] = TYPES[f.type] || "";
  if (f.type == "file") {
    FIELDS_VALIDATION[f.key + "_preview"] = Yup.string().required(
      "This Field Is Required"
    );
  } else if (f.type == "select" && f.isMulti) {
    FIELDS_VALIDATION[f.key] = Yup.array();
  } else {
    FIELDS_VALIDATION[f.key] = Yup.string().required("This Field Is Required");
  }
});

const AddWorkExperience = () => {
  const { t } = useTranslation();
  let navigate = useHistory();
  const { id:employeeId } = useParams()

  const { setData, loading, error, success } = useResponse(addWorkExperience, () => {
    navigate.goBack()
  });

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues,
    validationSchema: Yup.object(FIELDS_VALIDATION),
    onSubmit: (data) => {
      // console.log(data);
      const fullData = {...data, employeeId: +employeeId}
      setData({ data: fullData, type: "add" });
    },
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={t("Work Experience")}
            breadcrumbItem={t("Add") + " " + t("Work Experience")}
          />

          <Form
            className="needs-validation"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <WorkExperienceForm validation={validation} />

            <FormButtonHandler btnTxt="Add" loading={loading} />

            <ResultHandler
              error={error}
              success={success}
              successMsg={"Created Successfully!"}
            />
          </Form>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AddWorkExperience;
